import { useState } from 'react';

import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import LoadQueryButton from './LoadQueryButton';
import SaveQueryButton from './SaveQueryButton';
import { StyledButtonsWrapper } from '../styles';

const QueryButtons = ({
  getQueryList,
  onDeleteQuery,
  onDownload,
  onEditQueryName,
  onLoadQuery,
  onReset,
  onSaveQuery,
}) => {
  const { t } = useTranslation();

  const [downloading, setDownloading] = useState(false);

  const handleReset = () => onReset();
  const handleDownload = async () => {
    setDownloading(true);
    await onDownload();
    setDownloading(false);
  };

  return (
    <StyledButtonsWrapper>
      <SaveQueryButton onSaveQuery={onSaveQuery} />
      <LoadQueryButton
        getQueryList={getQueryList}
        onEditQueryName={onEditQueryName}
        onLoadQuery={onLoadQuery}
        onDeleteQuery={onDeleteQuery}
      />
      <Button
        variant={downloading ? 'contained' : 'outlined'}
        disabled={downloading}
        startIcon={
          downloading ? <CircularProgress size={20} /> : <DownloadIcon />
        }
        onClick={handleDownload}
      >
        {downloading
          ? t('pending', { ns: 'buttons' })
          : t('downloadWebApp', { ns: 'buttons' })}
      </Button>
      <Button
        color="error"
        variant="outlined"
        onClick={handleReset}
        startIcon={<DeleteIcon />}
      >
        {t('clear', { ns: 'buttons' })}
      </Button>
    </StyledButtonsWrapper>
  );
};

QueryButtons.propTypes = {
  getQueryList: PropTypes.func.isRequired,
  onDeleteQuery: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired,
  onEditQueryName: PropTypes.func.isRequired,
  onLoadQuery: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  onSaveQuery: PropTypes.func.isRequired,
};

export default QueryButtons;
